import { Sparkles, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { useSettings, waLink, telLink } from "@/lib/site";

export const LeadSection = ({ presetDistrict = "", title, subtitle }) => {
  const settings = useSettings();
  return (
    <section id="teklif" className="section-pad bg-[#0E0F10] scroll-mt-24">
      <div className="container-lux">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <Reveal>
            <div>
              <span className="eyebrow"><Sparkles className="w-4 h-4" /> Hazır mısınız?</span>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
                {title || "Tarihinizi alın, hayalinizi planlayalım"}
              </h2>
              <p className="text-[#9A9387] mt-4 max-w-lg">
                {subtitle ||
                  "Formu doldurun; uygun tarihleri ve size özel paket fiyatını paylaşalım. Şimdi ödeme yapmanız gerekmez."}
              </p>
              <div className="flex flex-wrap gap-3 mt-7">
                <a href={waLink(settings)} target="_blank" rel="noreferrer">
                  <Button size="lg" className="bg-[#C8A24A] text-[#141517] hover:bg-[#D7B86A] font-semibold">
                    <MessageCircle className="w-5 h-5 mr-2" /> WhatsApp'tan Yaz
                  </Button>
                </a>
                <a href={telLink(settings)}>
                  <Button size="lg" variant="outline" className="border-white/20 text-[#F7F2E8] bg-transparent hover:bg-white/5">
                    <Phone className="w-5 h-5 mr-2" /> {settings.phone}
                  </Button>
                </a>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="rounded-2xl bg-[#FBF7EF] p-6 sm:p-8 border border-black/5 shadow-[0_22px_50px_rgba(0,0,0,0.4)]">
              <h3 className="font-display text-2xl text-[#141517] mb-1">Teklif / Uygunluk Formu</h3>
              <p className="text-sm text-[#5B5F66] mb-5">30 saniyede doldurun, size dönelim.</p>
              <LeadForm presetDistrict={presetDistrict} />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default LeadSection;
